<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                @if (reactiveForm) {
                    <app-reactive-form-builder
                        #builderRef
                        (stableValueChanges)="stableValueChanges($event)"
                        (afterSend)="onAfterSend()"
                        (goBack)="goBack()"
                        [form]="reactiveForm.formFields"
                        [id]="reactiveFormRecordId"
                        [request]="request"
                        [getRequest]="albaranesApi.albaranesGET">
                    </app-reactive-form-builder>
                }
            </div>
        </div>

        <div class="row mb-1">
            <div class="col-md-1 col-12 flex align-items-center justify-content-center">
                <input type="file" #adjuntarFoto (change)="fileChange($event)" style="display: none;" accept="image/*" />
                <button *ngIf="model?.adjunto" class="btn btn-link" (click)="verAdjunto()">Ver</button>
                <input
                    type="button"
                    class="btn btn-success"
                    style='border-radius: 5px; font-size: 1em; padding: 6px 12px; font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;'
                    value="Añadir foto"
                    (click)="readUrl(adjuntarFoto)" />
            </div>

            <div class="d-flex flex-column align-items-center justify-content-center col-md-1 col-6">
                <span>Contabilizado</span>
                <input type="checkbox" [ngModel]="form.model.contabilizado" (change)="changeChecked('contabilizado', $event)" />
            </div>

            <div class="d-flex flex-column align-items-center justify-content-center col-md-2 col-6">
                <span>Enviado por Correo</span>
                <input type="checkbox" [ngModel]="form.model.enviado" (change)="changeChecked('enviado', $event)" />
            </div>
        </div>
    </div>
</p-panel>
